export default __webpack_public_path__ + "static/media/red.bff535c3.svg";